import { MutationTree } from 'vuex';
import { Grid } from '@/models/Grid.model';
import { initialState } from '@/store/modules/backoffice/customer';
import { MessagesState } from '@/store/modules/backoffice/messages/index';
import {
  MESSAGES_RESET_STATE,
  OPEN_CREATE_MESSAGE_MODAL, SET_MESSAGES_ALL_OFFICE_LIST,
  SET_MESSAGES_BY_CUSTOMER,
  SET_MESSAGES_BY_CUSTOMER_ERRORS,
  SET_MESSAGES_LOADING,
  SET_OPEN_CREATE_MESSAGE_MODAL,
  SET_OPEN_CREATE_MESSAGE_MODAL_ERRORS,
  SET_OPEN_DELETE_MESSAGES_MODAL, SET_OPEN_DELETE_MESSAGES_MODAL_ERRORS,
} from '@/types/backoffice/messages.types';
import { BackofficeMessageModel } from '@/models/BackofficeMessage.model';
import {
  OPEN_CREATE_REMINDERS_MODAL_ERRORS,
  SET_OPEN_DELETE_MANAGER_MODAL,
  SET_OPEN_DELETE_MANAGER_MODAL_ERRORS,
} from '@/types/customer.types';

export const mutations: MutationTree<MessagesState> = {

  [SET_MESSAGES_BY_CUSTOMER]: (state, messagesByCustomer: Grid<BackofficeMessageModel>) => {
    state.messagesByCustomer = messagesByCustomer;
  },

  [SET_MESSAGES_BY_CUSTOMER_ERRORS]: (state, messagesByCustomerErrors: string[]) => {
    state.messagesByCustomerErrors = messagesByCustomerErrors;
  },

  [SET_OPEN_CREATE_MESSAGE_MODAL]: (state, openCreateMessageModal: boolean) => {
    state.openCreateMessageModal = openCreateMessageModal;
  },

  [SET_OPEN_CREATE_MESSAGE_MODAL_ERRORS]: (state, openCreateMessageModalErrors: string[]) => {
    state.openCreateMessageModalErrors = openCreateMessageModalErrors;
  },

  [SET_OPEN_DELETE_MESSAGES_MODAL]: (state, openDeleteMessagesModal: boolean) => {
    state.openDeleteMessagesModal = openDeleteMessagesModal;
  },

  [SET_OPEN_DELETE_MESSAGES_MODAL_ERRORS]: (state, openDeleteMessagesModalErrors: string[]) => {
    state.openDeleteMessagesModalErrors = openDeleteMessagesModalErrors;
  },

  [SET_MESSAGES_ALL_OFFICE_LIST]: (state, messagesAllOfficeList: Grid) => {
    state.messagesAllOfficeList = messagesAllOfficeList;
  },

  // [SET_CUSTOMER_DETAILS]: (state, customerDetails: CustomerDetailsModel) => {
  //   state.customerDetails = customerDetails;
  // },
  //
  // [SET_UPDATE_CUSTOMER_SETTINGS_MODAL]: (state, updateCustomerSettingsModal: boolean) => {
  //   state.updateCustomerSettingsModal = updateCustomerSettingsModal;
  // },
  //
  // [SET_UPDATE_CUSTOMER_SETTINGS_MODAL_ERRORS]: (state, updateCustomerSettingsModalErrors: string[]) => {
  //   state.updateCustomerSettingsModalErrors = updateCustomerSettingsModalErrors;
  // },
  //
  // [SET_ALL_OFFICES_BY_CUSTOMER]: (state, allOfficesByCustomer: Grid) => {
  //   state.allOfficesByCustomer = allOfficesByCustomer;
  // },
  //
  // [SET_ALL_OFFICES_ERRORS]: (state, allOfficesErrors: string[]) => {
  //   state.allOfficesErrors = allOfficesErrors;
  // },
  //
  // [SET_OFFICE_DETAILS]: (state, officesDetails: CustomerDetailsModel) => {
  //   state.officeDetails = officesDetails;
  // },
  //
  // [SET_UPDATE_OFFICE_SETTINGS_MODAL]: (state, updateOfficeSettingsModal: boolean) => {
  //   state.updateOfficeSettingsModal = updateOfficeSettingsModal;
  // },
  //
  // [SET_UPDATE_OFFICE_SETTINGS_MODAL_ERRORS]: (state, updateOfficeSettingsModalErrors: string[]) => {
  //   state.updateOfficeSettingsModalErrors = updateOfficeSettingsModalErrors;
  // },
  //
  // [SET_ALL_REMINDERS_BY_CUSTOMER]: (state, allRemindersByCustomer: Grid) => {
  //   state.allRemindersByCustomer = allRemindersByCustomer;
  // },
  //
  // [SET_OPEN_CREATE_REMINDERS_MODAL]: (state, openCreateRemindersModal: boolean) => {
  //   state.openCreateRemindersModal = openCreateRemindersModal;
  // },
  //
  // [SET_OPEN_CREATE_REMINDERS_MODAL_ERRORS]: (state, openCreateRemindersModalErrors: string[]) => {
  //   state.openCreateRemindersModalErrors = openCreateRemindersModalErrors;
  // },
  //
  // [SET_MANAGERS_BY_CUSTOMER]: (state, managersByCustomer: Grid) => {
  //   state.managersByCustomer = managersByCustomer;
  // },
  //
  // [SET_MANAGER_TO_ADD]: (state, managerToAdd: Grid) => {
  //   state.managerToAdd = managerToAdd;
  // },
  //
  // [SET_MANAGER_TO_DELETE]: (state, managerToDelete: ManagerPrivilegesModel | null) => {
  //   state.managerToDelete = managerToDelete;
  // },
  //
  // [SET_OPEN_DELETE_MANAGER_MODAL]: (state, openDeleteManagerModal: boolean) => {
  //   state.openDeleteManagerModal = openDeleteManagerModal;
  // },
  //
  // [SET_OPEN_DELETE_MANAGER_MODAL_ERRORS]: (state, openDeleteManagerModalErrors: string[]) => {
  //   state.openDeleteManagerModalErrors = openDeleteManagerModalErrors;
  // },
  //
  // [SET_MANAGER_TO_UPDATE]: (state, managerToUpdate: ManagerPrivilegesModel | null) => {
  //   state.managerToUpdate = managerToUpdate;
  // },
  //
  // [SET_OPEN_UPDATE_MANAGER_MODAL]: (state, openUpdateManagerModal: boolean) => {
  //   state.openUpdateManagerModal = openUpdateManagerModal;
  // },
  //
  // [SET_OPEN_UPDATE_MANAGER_MODAL_ERRORS]: (state, openUpdateManagerModalErrors: string[]) => {
  //   state.openUpdateManagerModalErrors = openUpdateManagerModalErrors;
  // },
  //
  // [SET_OPEN_ADD_MANAGER_MODAL]: (state, openAddManagerModal: boolean) => {
  //   state.openAddManagerModal = openAddManagerModal;
  // },
  //
  // [SET_OPEN_ADD_MANAGER_MODAL_ERRORS]: (state, openAddManagerModalErrors: string[]) => {
  //   state.openAddManagerModalErrors = openAddManagerModalErrors;
  // },
  //
  // [SET_ORG_UNITS]: (state, orgUnits: OrganisationUnitModel) => {
  //   if (orgUnits) {
  //     if (state.orgUnits.length) {
  //       const updatedOrgUnits = [...state.orgUnits];
  //       updatedOrgUnits[orgUnits.index] = orgUnits;
  //       state.orgUnits = updatedOrgUnits;
  //     } else {
  //       state.orgUnits = [orgUnits];
  //     }
  //   } else {
  //     state.orgUnits = [];
  //   }
  // },
  //
  // [SET_MANAGER_PRIVILEGES]: (state, managerPrivileges: any) => {
  //   state.managerPrivileges = managerPrivileges;
  // },
  //
  [SET_MESSAGES_LOADING]: (state, messagesLoading: boolean) => {
    state.messagesLoading = messagesLoading;
  },

  [MESSAGES_RESET_STATE]: (state) => {
    state = Object.assign(state, initialState());
  },

};
